// import React, { useEffect, useMemo, useRef, useState } from "react";
// import Tree from "react-d3-tree";
// import api from "../../api";
// import MyImg from "../../assets/images/users/user-dummy-img.jpg";
// import "../../../src/assets/styles/orgchart.css";
// import { Card, CardBody, CardHeader } from "reactstrap";

// const DEPARTMENT_COLORS = {
//     IT: "#3B5CCC",
//     Accounting: "#1DA1F2",
//     Engineering: "#2CA24F",
//     HR: "#F4B000",
//     Planning: "#BFC6F7",
//     Production: "#F4DFDF",
//     Shipping: "#5C6BC0",
//     Quality: "#9EA7B8",
//     Default: "#6c757d",
// };
// const DEPARTMENT_MAP = {
//     1: { name: "IT", color: "#3B5CCC" },
//     39: { name: "Accounting", color: "#1DA1F2" },
//     49: { name: "Engineering", color: "#2CA24F" },
//     69: { name: "HR", color: "#F4B000" },
//     94: { name: "Planning", color: "#BFC6F7" },
//     95: { name: "Production", color: "#F4DFDF" },
//     71: { name: "Shipping", color: "#5C6BC0" },
//     72: { name: "Quality", color: "#9EA7B8" },
//     82: { name: "Shukla", color: "#7E57C2" },
//     84: { name: "Sales", color: "#26A69A" },
//     93: { name: "Supervisor", color: "#FF7043" },
//     96: { name: "KPIs", color: "#8D6E63" },
//     59: { name: "Human Resource", color: "#F4B000" },
//     91: { name: "Information Technology", color: "#3B5CCC" },
//     76: { name: "Production", color: "#F4DFDF" },
//     19: { name: "Engineering", color: "#2CA24F" },
//     29: { name: "Accounting", color: "#1DA1F2" },
// };

// const getDepartmentMeta = (dept) => {
//     if (dept === null || dept === undefined || dept === "") {
//         return { name: "Unknown", color: "#6c757d" };
//     }

//     const key = String(dept).trim();
//     return DEPARTMENT_MAP[key] || { name: key, color: "#6c757d" };
// };

// const normalizeDepartment = (dept) => {
//     if (!dept) return "Default";
//     const text = String(dept).trim();
//     const match = Object.keys(DEPARTMENT_COLORS).find(
//         (k) => k.toLowerCase() === text.toLowerCase()
//     );
//     return match || text;
// };

// const getDepartmentColor = (dept) => {
//     const normalized = normalizeDepartment(dept);
//     return DEPARTMENT_COLORS[normalized] || DEPARTMENT_COLORS.Default;
// };

// const OrganizationalChart = () => {
//     const [treeData, setTreeData] = useState(null);
//     const [selectedEmployee, setSelectedEmployee] = useState(null);
//     const [employeeDetails, setEmployeeDetails] = useState(null);
//     const [translate, setTranslate] = useState({ x: 0, y: 0 });
//     const [zoom, setZoom] = useState(0.9);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [flatList, setFlatList] = useState([]);
//     const [pathMap, setPathMap] = useState({});
//     const [highlightedNode, setHighlightedNode] = useState(null);
//     const [showLegend, setShowLegend] = useState(true);
//     const [searchOpen, setSearchOpen] = useState(false);
//     const treeContainer = useRef(null);

//     useEffect(() => {
//         api
//             .get("OrgChart")
//             .then((res) => {
//                 const root = Array.isArray(res.data) ? res.data[0] : res.data;
//                 const mapped = mapToRawNode(root);

//                 setTreeData(mapped);
//                 setSelectedEmployee(mapped);

//                 const flat = flattenTree(mapped);
//                 setFlatList(flat);

//                 const map = buildPathMap(mapped);
//                 setPathMap(map);

//                 setTimeout(() => {
//                     if (treeContainer.current) {
//                         const { width, height } =
//                             treeContainer.current.getBoundingClientRect();
//                         setTranslate({ x: width / 2, y: 110 });
//                     }
//                 }, 200);
//             })
//             .catch((err) => console.error("Error loading org chart:", err));
//     }, []);

//     const fetchEmployeeInfo = async (empId) => {
//         if (!empId) return;
//         try {
//             const res = await api.get(`OrgChart/${empId}`);
//             setEmployeeDetails(res.data);
//         } catch (err) {
//             console.error("Error fetching employee details:", err);
//             setEmployeeDetails(null);
//         }
//     };

//     const flattenTree = (node, arr = []) => {
//         if (!node) return arr;

//         arr.push({
//             empid: node.attributes?.empid,
//             name: node.name,
//             title: node.attributes?.title,
//             department: node.attributes?.department,
//             email: node.attributes?.email,
//             cell: node.attributes?.cell,
//             photoBase64: node.photoBase64,
//         });

//         if (node.children) {
//             node.children.forEach((child) => flattenTree(child, arr));
//         }

//         return arr;
//     };

//     const mapToRawNode = (node, visited = new Set()) => {
//         if (!node || visited.has(node.empId)) return null;
//         visited.add(node.empId);

//         const subs = Array.isArray(node.subordinates)
//             ? node.subordinates
//             : node.subordinates?.$values || [];

//         const children = subs
//             .filter((c) => c && c.empId && c.empId !== node.empId)
//             .map((c) => mapToRawNode(c, visited))
//             .filter(Boolean);

//         return {
//             name: `${node.firstName || ""} ${node.lastName || ""}`.trim(),
//             attributes: {
//                 empid: node.empId,
//                 title: node.title || "",
//                 department: node.department || "",
//                 email: node.emailAddress || "",
//                 cell: node.cell || "",
//             },
//             photoBase64: node.photoBase64 || null,
//             children: children.length > 0 ? children : undefined,
//         };
//     };

//     const buildPathMap = (node, path = [], map = {}) => {
//         if (!node) return map;
//         map[node.name] = [...path, node.name];
//         if (node.children) {
//             node.children.forEach((child) =>
//                 buildPathMap(child, [...path, node.name], map)
//             );
//         }
//         return map;
//     };

//     const expandPath = (node, path) => {
//         if (!node || !path.length) return;
//         const nextName = path[0];

//         if (node.name === nextName && node.children) {
//             node._collapsed = false;
//             node.children.forEach((child) => expandPath(child, path.slice(1)));
//         } else if (node.children) {
//             node.children.forEach((child) => expandPath(child, path));
//         }
//     };

//     const expandAllNodes = (node) => {
//         if (!node) return;
//         node._collapsed = false;
//         if (node.children) node.children.forEach(expandAllNodes);
//     };

//     const collapseAllNodes = (node, isRoot = true) => {
//         if (!node) return;
//         if (!isRoot) node._collapsed = true;
//         if (node.children) node.children.forEach((child) => collapseAllNodes(child, false));
//     };

//     const smoothCenterTransition = (targetX, targetY, duration = 500) => {
//         const start = performance.now();
//         const initial = { ...translate };

//         const animate = (time) => {
//             const progress = Math.min((time - start) / duration, 1);
//             setTranslate({
//                 x: initial.x + (targetX - initial.x) * progress,
//                 y: initial.y + (targetY - initial.y) * progress,
//             });
//             if (progress < 1) requestAnimationFrame(animate);
//         };

//         requestAnimationFrame(animate);
//     };

//     const centerNodeByElement = (nodeName) => {
//         const nodeEl = document.getElementById(`node-${nodeName.replace(/\s+/g, "-")}`);
//         const chartEl = treeContainer.current;

//         if (nodeEl && chartEl) {
//             const chartRect = chartEl.getBoundingClientRect();
//             const nodeRect = nodeEl.getBoundingClientRect();

//             const deltaX =
//                 chartRect.width / 2 -
//                 (nodeRect.left - chartRect.left + nodeRect.width / 2);

//             const deltaY =
//                 chartRect.height / 2 -
//                 (nodeRect.top - chartRect.top + nodeRect.height / 2);

//             smoothCenterTransition(translate.x + deltaX, translate.y + deltaY, 600);
//         }
//     };

//     const handleNodeSelect = (nodeDatum, toggleNode) => {
//         const { name, attributes, photoBase64 } = nodeDatum;
//         setSelectedEmployee({ name, attributes, photoBase64 });
//         setHighlightedNode(name);

//         if (attributes?.empid) {
//             fetchEmployeeInfo(attributes.empid);
//         } else {
//             setEmployeeDetails(null);
//         }

//         if (toggleNode) toggleNode();

//         setTimeout(() => {
//             centerNodeByElement(name);
//         }, 150);

//         setTimeout(() => setHighlightedNode(null), 1800);
//     };

//     const handleSearchSelect = (emp) => {
//         setSearchQuery(emp.name);
//         setSearchOpen(false);

//         setSelectedEmployee({
//             name: emp.name,
//             photoBase64: emp.photoBase64,
//             attributes: {
//                 empid: emp.empid,
//                 title: emp.title || "",
//                 department: emp.department || "",
//                 email: emp.email || "",
//                 cell: emp.cell || "",
//             },
//         });

//         setHighlightedNode(emp.name);
//         fetchEmployeeInfo(emp.empid);

//         const path = pathMap[emp.name];
//         if (path && treeData) {
//             const cloned = JSON.parse(JSON.stringify(treeData));
//             expandPath(cloned, path);
//             setTreeData(cloned);
//         }

//         setTimeout(() => {
//             centerNodeByElement(emp.name);
//         }, 350);

//         setTimeout(() => setHighlightedNode(null), 1800);
//     };

//     // const handleZoomIn = () => setZoom((z) => Math.min(z + 0.15, 1.8));
//     // const handleZoomOut = () => setZoom((z) => Math.max(z - 0.15, 0.4));

//     const handleReset = () => {
//         if (!treeContainer.current) return;
//         const { width } = treeContainer.current.getBoundingClientRect();
//         smoothCenterTransition(width / 2, 110, 500);
//         setZoom(0.9);
//     };

//     const handleExpandAll = () => {
//         if (!treeData) return;
//         const cloned = JSON.parse(JSON.stringify(treeData));
//         expandAllNodes(cloned);
//         setTreeData(cloned);
//     };

//     const handleCollapseAll = () => {
//         if (!treeData) return;
//         const cloned = JSON.parse(JSON.stringify(treeData));
//         collapseAllNodes(cloned, true);
//         setTreeData(cloned);
//     };

//     const filteredResults = useMemo(() => {
//         if (!searchQuery.trim()) return [];
//         const q = searchQuery.toLowerCase();
//         return flatList
//             .filter(
//                 (emp) =>
//                     emp.name?.toLowerCase().includes(q) ||
//                     emp.title?.toLowerCase().includes(q) ||
//                     emp.department?.toLowerCase().includes(q)
//             )
//             .slice(0, 8);
//     }, [searchQuery, flatList]);

//     const departmentLegend = useMemo(() => {
//         const allDepts = flatList.map((e) => normalizeDepartment(e.department));
//         return [...new Set(allDepts)].filter(Boolean);
//     }, [flatList]);

//     const renderNode = ({ nodeDatum, toggleNode }) => {
//         const { name, attributes, photoBase64 } = nodeDatum;

//         const title = attributes?.title || "";

//         const department = attributes?.department || "";
//         const deptMeta = getDepartmentMeta(department);
//         const deptColor = deptMeta.color;
//         const isHighlighted = highlightedNode === name;

//         return (
//             <g id={`node-${name.replace(/\s+/g, "-")}`}>
//                 <foreignObject width={208} height={110} x={-104} y={-55}>
//                     <div
//                         className={`org-node-card ${isHighlighted ? "is-highlighted" : ""}`}
//                         onClick={() => handleNodeSelect(nodeDatum, toggleNode)}
//                     >
//                         <div
//                             className="org-node-topbar"
//                             style={{ backgroundColor: deptColor }}
//                         />
//                         <div className="org-node-inner">
//                             <img
//                                 src={photoBase64 ? `data:image/jpeg;base64,${photoBase64}` : MyImg}
//                                 alt={name}
//                                 className="org-node-avatar"
//                             />

//                             <div className="org-node-text">
//                                 <div className="org-node-name">{name}</div>
//                                 <div className="org-node-title">{title}</div>
//                             </div>
//                         </div>
//                     </div>
//                 </foreignObject>
//             </g>
//         );
//     };

//     const selectedImage = selectedEmployee?.photoBase64
//         ? `data:image/jpeg;base64,${selectedEmployee.photoBase64}`
//         : MyImg;

//     return (
//         <React.Fragment>
//             <Card className="orgchart-main-card">
//                 {/* <CardHeader className="orgchart-page-header">
//                     <div>
//                         <h4 className="card-title mb-1">Organizational Chart</h4>
//                         <div className="orgchart-breadcrumb-sub">Dashboards &gt; Organizational Chart</div>
//                     </div>
//                 </CardHeader> */}

//                 <CardBody className="orgchart-page-body">
//                     <div className="orgchart-toolbar">
//                         <div className="orgchart-searchWrap">
//                             <i className="ri-search-line orgchart-searchIcon" />
//                             <input
//                                 type="text"
//                                 placeholder="Search for employee, department"
//                                 value={searchQuery}
//                                 onChange={(e) => {
//                                     setSearchQuery(e.target.value);
//                                     setSearchOpen(true);
//                                 }}
//                                 onFocus={() => setSearchOpen(true)}
//                                 className="orgchart-search"
//                             />

//                             {searchOpen && filteredResults.length > 0 && (
//                                 <div className="orgchart-searchResults">
//                                     {filteredResults.map((emp, idx) => (
//                                         <div
//                                             key={`${emp.name}-${idx}`}
//                                             className="orgchart-searchItem"
//                                             onMouseDown={() => handleSearchSelect(emp)}
//                                         >
//                                             <img
//                                                 src={
//                                                     emp.photoBase64
//                                                         ? `data:image/jpeg;base64,${emp.photoBase64}`
//                                                         : MyImg
//                                                 }
//                                                 alt={emp.name}
//                                                 className="orgchart-searchThumb"
//                                             />
//                                             <div>
//                                                 <div className="orgchart-searchName">{emp.name}</div>
//                                                 <div className="orgchart-searchSub">
//                                                     {emp.title} {emp.department ? `• ${emp.department}` : ""}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>

//                         <div className="orgchart-toolbar-actions">
//                             <button onClick={handleReset} type="button"
//                                 className="orgchart-toolbtn" >
//                                 ⟳  Reset View
//                             </button>
//                             <button
//                                 onClick={() => {
//                                     if (selectedEmployee?.name) centerNodeByElement(selectedEmployee.name);
//                                 }}
//                                 type="button"
//                                 className="orgchart-toolbtn"
//                                 title="Center Selected"
//                             >
//                                 ⤢  Center Selected
//                             </button>
//                             <button
//                                 type="button"
//                                 className="orgchart-toolbtn"
//                                 onClick={() => setShowLegend((s) => !s)}
//                             >
//                                 <i className="ri-information-line" />
//                                 {showLegend ? "Hide Legend" : "Show Legend"}
//                             </button>

//                             <button
//                                 type="button"
//                                 className="orgchart-toolbtn"
//                                 onClick={handleExpandAll}
//                             >
//                                 <i className="ri-fullscreen-line" />
//                                 Expand All
//                             </button>

//                             <button
//                                 type="button"
//                                 className="orgchart-toolbtn"
//                                 onClick={handleCollapseAll}
//                             >
//                                 <i className="ri-collapse-diagonal-line" />
//                                 Collapse All
//                             </button>
//                         </div>
//                     </div>

//                     {showLegend && (
//                         <div className="orgchart-legendbar">
//                             <div className="orgchart-legend-left">
//                                 <strong>Total Employees:</strong> {flatList.length}
//                             </div>

//                             <div className="orgchart-legend-right">
//                                 <span className="orgchart-legend-title">Departments :</span>
//                                 {departmentLegend.map((dept) => (
//                                     <span className="orgchart-legend-item" key={dept}>
//                                         <span
//                                             className="orgchart-legend-dot"
//                                             style={{ backgroundColor: getDepartmentColor(dept) }}
//                                         />
//                                         {dept}
//                                     </span>
//                                 ))}
//                             </div>
//                         </div>
//                     )}

//                     <div className="orgchart-canvas" ref={treeContainer}>
//                         <div className="orgchart-tip">
//                             <strong>Tip :</strong> Click on any employee card to expand or collapse
//                         </div>

//                         {selectedEmployee && (
//                             <div className="orgchart-detail-float">
//                                 <button
//                                     type="button"
//                                     className="orgchart-detail-close"
//                                     onClick={() => setSelectedEmployee(null)}
//                                 >
//                                     ×
//                                 </button>

//                                 <div className="orgchart-detail-grid">
//                                     <div className="orgchart-detail-left">
//                                         <img
//                                             src={selectedImage}
//                                             alt={selectedEmployee.name}
//                                             className="orgchart-detail-photo"
//                                         />
//                                         <div className="orgchart-detail-name">{selectedEmployee.name}</div>
//                                     </div>

//                                     <div className="orgchart-detail-right">
//                                         <div className="orgchart-detail-title">
//                                             {selectedEmployee.attributes?.title || "—"}
//                                         </div>

//                                         <div className="orgchart-detail-row">
//                                             <i className="ri-mail-line" />
//                                             <span>
//                                                 {employeeDetails?.email ||
//                                                     selectedEmployee.attributes?.email ||
//                                                     "—"}
//                                             </span>
//                                         </div>

//                                         <div className="orgchart-detail-row">
//                                             <i className="ri-phone-line" />
//                                             <span>
//                                                 {employeeDetails?.cell ||
//                                                     selectedEmployee.attributes?.cell ||
//                                                     "—"}
//                                             </span>
//                                         </div>

//                                         <div className="orgchart-detail-row">
//                                             <i className="ri-building-line" />
//                                             <span>
//                                                 {employeeDetails?.departmentName ||
//                                                     selectedEmployee.attributes?.department ||
//                                                     "—"}
//                                             </span>
//                                         </div>

//                                         <div className="orgchart-detail-meta">
//                                             <div>
//                                                 <span>Joined On</span>
//                                                 <strong>
//                                                     {employeeDetails?.joinDate
//                                                         ? new Date(employeeDetails.joinDate).toLocaleDateString()
//                                                         : "—"}
//                                                 </strong>
//                                             </div>
//                                             <div>
//                                                 <span>DOB</span>
//                                                 <strong>
//                                                     {employeeDetails?.dob
//                                                         ? new Date(employeeDetails.dob).toLocaleDateString()
//                                                         : "—"}
//                                                 </strong>
//                                             </div>
//                                             <div>
//                                                 <span>Manager</span>
//                                                 <strong>{employeeDetails?.managerName || "—"}</strong>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}

//                         {treeData && (
//                             <Tree
//                                 data={treeData}
//                                 translate={translate}
//                                 zoom={zoom}
//                                 onZoom={setZoom}
//                                 orientation="vertical"
//                                 pathFunc="step"
//                                 collapsible
//                                 zoomable
//                                 scaleExtent={{ min: 0.4, max: 1.8 }}
//                                 separation={{ siblings: 1.75, nonSiblings: 2.1 }}
//                                 transitionDuration={400}
//                                 renderCustomNodeElement={renderNode}
//                             />
//                         )}

//                         <div className="orgchart-floating-controls">
//                             {/* <button onClick={handleZoomIn} className="orgchart-fab" title="Zoom In">
//                                 +
//                             </button>
//                             <button onClick={handleZoomOut} className="orgchart-fab" title="Zoom Out">
//                                 −
//                             </button> */}
//                             {/* <button onClick={handleReset} className="orgchart-fab" title="Reset View">
//                                 ⟳
//                             </button>
//                             <button
//                                 onClick={() => {
//                                     if (selectedEmployee?.name) centerNodeByElement(selectedEmployee.name);
//                                 }}
//                                 className="orgchart-fab"
//                                 title="Center Selected"
//                             >
//                                 ⤢
//                             </button> */}
//                         </div>
//                     </div>
//                 </CardBody>
//             </Card>
//         </React.Fragment>
//     );
// };

// export default OrganizationalChart;

// OrganizationalChart.jsx


// OrganizationalChart.jsx
import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import Tree from "react-d3-tree";
import api from "../../api";
import MyImg from "../../assets/images/users/user-dummy-img.jpg";
import "../../assets/styles/orgchart.css";
import useOrgPresence, { PresenceDot, PresencePill, PresenceReadout } from "./useOrgPresence";
import { Card, CardBody, Alert } from "reactstrap";
// Round ORG-2 (2026) — shared CSV export + length-of-service helpers (same
// module the Compact view uses, so exports match across views).
import { exportOrgRowsToCsv, lengthOfService, deptColor } from "./orgCsv";
import { inkFor } from "../../utils/themeColor";
import { Link } from "react-router-dom";

// ─── Static color palette ────────────────────────────────────────────────────
// Go-live parity (2026-09-24): the palette moved to deptColor() in orgCsv.js
// (shared with the Compact view — one fixed colour per department).

const assignColors = (depts) => {
    const map = {};
    depts.forEach((d) => {
        map[String(d.jcDept1).trim()] = {
            name: d.description,
            color: deptColor(d.jcDept1),   // Go-live parity (2026-09-24): fixed colour per department
        };
    });
    return map;
};

const getDeptMeta = (deptMap, dept) => {
    if (!dept && dept !== 0) return { name: "—", color: "#9EA7B8", unmatched: true };
    const hit = deptMap[String(dept).trim()];
    if (hit && hit.name && String(hit.name).trim()) return hit;
    // Round ORG-UAT-1 (2026) — a code with no entry in the JCDepts master
    // (e.g. "20" for an SN/legacy department not in the SSW list) previously
    // rendered as the bare number on the card and legend. Show a neutral
    // label instead and flag it so the legend can omit it.
    return { name: "Unassigned", color: "#9EA7B8", unmatched: true };
};

const countDescendants = (node) => {
    // check both children (expanded) and _children (collapsed)
    const kids = node?.children?.length ? node.children : (node?._children || []);
    if (!kids.length) return 0;
    return kids.reduce((acc, c) => acc + 1 + countDescendants(c), 0);
};

// ─── Flatten all subordinates of a node into a flat array ───────────────────
const flattenSubordinates = (node, arr = []) => {
    if (!node?.children?.length) return arr;
    node.children.forEach((c) => {
        arr.push(c);
        flattenSubordinates(c, arr);
    });
    return arr;
};

// ─── Build dept breakdown from a flat list ──────────────────────────────────
const buildDeptBreakdown = (nodes, deptMap) => {
    const counts = {};
    nodes.forEach((n) => {
        const key = String(n.attributes?.department || "").trim();
        counts[key] = (counts[key] || 0) + 1;
    });
    return Object.entries(counts)
        .map(([key, count]) => ({ ...getDeptMeta(deptMap, key), key, count }))
        .sort((a, b) => b.count - a.count);
};

const OrganizationalChart = ({ initialViewMode = "team", canEditInHr = false }) => {
    const [treeData, setTreeData] = useState(null);
    // Owner 2026-10-12: green IN / red OUT circle on every person (legacy OrgChart.vb).
    const presence = useOrgPresence();
    const presenceOf = (id) => presence.byId[String(id ?? "").trim()];
    // Round ORG-2 — controlled load/error states so a failed API call shows a
    // message instead of a blank canvas (acceptance criterion 45).
    const [loadError, setLoadError] = useState(null);
    const [deptMap, setDeptMap] = useState({});
    const [selectedNode, setSelectedNode] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState(null);
    const [translate, setTranslate] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(0.85);
    const [searchQuery, setSearchQuery] = useState("");
    const [flatList, setFlatList] = useState([]);
    const [pathMap, setPathMap] = useState({});
    const [highlightedNode, setHighlightedNode] = useState(null);
    const [showLegend, setShowLegend] = useState(true);
    // Round ORG-2a — legend chips are a FILTER (owner request): the resolved
    // department NAME currently selected, or null for "show everyone".
    const [legendFilter, setLegendFilter] = useState(null);
    const [searchOpen, setSearchOpen] = useState(false);
    // Round ORG-UAT-1 (2026) — layout restructure. Default to a modern
    // DRILL-DOWN "Team View" (the BambooHR / MS-Teams pattern): show one
    // manager + their direct reports as a responsive card grid with a
    // breadcrumb trail, instead of rendering the whole tree at once. A
    // manager with 78 reports becomes a clean grid you page through, never
    // a horizontal wall. The classic connected tree stays one click away.
    // Every detail (side panel, tabs, stats, contact) is reused unchanged.
    const [viewMode, setViewMode] = useState(initialViewMode);  // "team" | "tree"
    const [focusNode, setFocusNode] = useState(null);  // current manager in Team View

    // ── Side panel state ──────────────────────────────────────────────────────
    const [sidePanelOpen, setSidePanelOpen] = useState(false);
    const [sidePanelNode, setSidePanelNode] = useState(null);   // the clicked node datum
    const [sidePanelSubList, setSidePanelSubList] = useState([]);     // flat subordinate list
    const [sidePanelFilter, setSidePanelFilter] = useState("");     // search within panel
    const [sidePanelDeptFilter, setSidePanelDeptFilter] = useState("ALL"); // dept tab
    const [sidePanelView, setSidePanelView] = useState("list"); // "list" | "summary"

    const treeContainer = useRef(null);

    /* ─── Init ────────────────────────────────────────────────────────────── */
    useEffect(() => {
        const init = async () => {
            try {
                const deptRes = await api.get("Department");
                const deptList = deptRes.data?.value ?? deptRes.data ?? [];
                const map = assignColors(deptList);
                setDeptMap(map);

                const ocRes = await api.get("OrgChart");
                // Round ORG-2 — the backend now flags fragment roots with
                // isDisconnected=true (a data-driven flag, not a person rule).
                // Team/Tree render the PRIMARY company tree; fragments are
                // surfaced to HR in the Compact view's review strip and the
                // HR data-quality panel — never silently grafted or lost.
                const rootsArr = Array.isArray(ocRes.data) ? ocRes.data : [ocRes.data];
                const root = rootsArr.find((r) => r && r.isDisconnected !== true) || rootsArr[0];
                const mapped = mapToRawNode(root);
                setTreeData(mapped);
                setSelectedNode({ datum: mapped, pos: null });
                // Round ORG-UAT-1 — Team View starts focused on the top node.
                setFocusNode(mapped);

                const flat = flattenTree(mapped);
                setFlatList(flat);
                setPathMap(buildPathMap(mapped));

                setTimeout(() => {
                    if (treeContainer.current) {
                        const { width } = treeContainer.current.getBoundingClientRect();
                        setTranslate({ x: width / 2, y: 90 });
                    }
                }, 200);
            } catch (err) {
                console.error("Init error:", err);
                setLoadError(
                    err?.response?.data?.message || err?.message || "Failed to load the organizational chart."
                );
            }
        };
        init();
    }, []);

    /* ─── Tree helpers ────────────────────────────────────────────────────── */
    const mapToRawNode = (node, visited = new Set()) => {
        if (!node || visited.has(node.empId)) return null;
        visited.add(node.empId);
        const subs = Array.isArray(node.subordinates)
            ? node.subordinates
            : node.subordinates?.$values || [];
        const children = subs
            .filter((c) => c && c.empId && c.empId !== node.empId)
            .map((c) => mapToRawNode(c, visited))
            .filter(Boolean);
        return {
            name: `${node.firstName || ""} ${node.lastName || ""}`.trim(),
            attributes: {
                empid: node.empId,
                title: node.title || "",
                department: node.department || "",
                email: node.emailAddress || "",
                cell: node.cell || "",
                // Round ORG-2 — additive fields from the enriched payload.
                extension: node.extension || "",
                hireDate: node.hireDate || null,
                directReports: node.directReports ?? 0,
                totalReports: node.totalReports ?? 0,
            },
            photoBase64: node.photoBase64 || null,
            children: children.length > 0 ? children : undefined,
        };
    };

    const flattenTree = (node, arr = []) => {
        if (!node) return arr;
        arr.push({ ...node.attributes, name: node.name, photoBase64: node.photoBase64 });
        node.children?.forEach((c) => flattenTree(c, arr));
        return arr;
    };

    const buildPathMap = (node, path = [], map = {}) => {
        if (!node) return map;
        map[node.name] = [...path, node.name];
        node.children?.forEach((c) => buildPathMap(c, [...path, node.name], map));
        return map;
    };

    const expandPath = (node, path) => {
        if (!node || !path.length) return;
        // restore _children if this node was collapsed
        if (node._children) {
            node.children = node._children;
            delete node._children;
        }
        if (node.__rd3t) node.__rd3t.collapsed = false;
        if (node.name === path[0]) {
            node.children?.forEach((c) => expandPath(c, path.slice(1)));
        } else {
            node.children?.forEach((c) => expandPath(c, path));
        }
    };

    const expandAllNodes = (node) => {
        if (!node) return;
        // restore hidden children back to visible
        if (node.__rd3t?.collapsed) {
            node.__rd3t.collapsed = false;
        }
        if (node._children) {
            node.children = node._children;
            delete node._children;
        }
        node.children?.forEach(expandAllNodes);
    };

    const collapseAllNodes = (node, isRoot = true) => {
        if (!node) return;
        // recurse children first (depth-first) so nested nodes collapse before parents
        node.children?.forEach((c) => collapseAllNodes(c, false));
        if (!isRoot && node.children?.length) {
            // hide children by moving them to _children
            node._children = node.children;
            node.children = [];
            if (node.__rd3t) node.__rd3t.collapsed = true;
        }
    };

    const smoothPan = (tx, ty, duration = 500) => {
        const start = performance.now();
        const initial = { ...translate };
        const animate = (now) => {
            const p = Math.min((now - start) / duration, 1);
            setTranslate({ x: initial.x + (tx - initial.x) * p, y: initial.y + (ty - initial.y) * p });
            if (p < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    };

    // Round ORG-UAT-1 (2026) — re-center whenever the layout flips so the
    // root lands in the right origin for the new orientation.
    const fetchDetail = async (empId) => {
        if (!empId) return setEmployeeDetails(null);
        try { const res = await api.get(`OrgChart/${empId}`); setEmployeeDetails(res.data); }
        catch { setEmployeeDetails(null); }
    };

    // Round ORG-UAT-1 (2026) — TREE VIEW AUTO-FIT.
    // react-d3-tree has no built-in "fit to screen", so a wide, flat org
    // sprawls off the right edge. This measures the actual rendered SVG
    // group (all nodes + links) via getBBox and computes the zoom + translate
    // that centres the whole tree inside the visible canvas, with padding.
    // Runs after render, on layout/orientation change, and on Reset/Fit.
    const fitTreeToScreen = useCallback((animate = true) => {
        const container = treeContainer.current;
        if (!container) return;
        // react-d3-tree wraps all drawn nodes in <g class="rd3t-g"> (v3);
        // fall back to the first <g> for any version difference.
        const svg = container.querySelector("svg");
        const g =
            container.querySelector("svg g.rd3t-g") ||
            container.querySelector("svg .rd3t-g") ||
            container.querySelector("svg > g") ||
            container.querySelector("svg g");
        if (!svg || !g) return;

        let bbox;
        try { bbox = g.getBBox(); } catch { return; }
        if (!bbox || bbox.width === 0 || bbox.height === 0) return;

        const { width: cw, height: ch } = container.getBoundingClientRect();
        const pad = 48;
        // Round ORG-UAT-1 (2026) — clean top-down fit (UAT-3 behavior): scale
        // the whole tree to fit both dimensions, with a legible floor so
        // cards never shrink into an unreadable strip. Since Tree View now
        // opens COLLAPSED to depth 1, the visible tree is small and this
        // frames it nicely; expanding a branch re-fits.
        const scale = Math.max(
            0.25,
            Math.min(1.2, Math.min((cw - pad * 2) / bbox.width, (ch - pad * 2) / bbox.height))
        );
        const bboxCx = bbox.x + bbox.width / 2;
        const bboxCy = bbox.y + bbox.height / 2;
        const tx = cw / 2 - scale * bboxCx;
        const ty = ch / 2 - scale * bboxCy;

        setZoom(scale);
        if (animate) smoothPan(tx, ty, 450);
        else setTranslate({ x: tx, y: ty });

        setZoom(scale);
        if (animate) smoothPan(tx, ty, 450);
        else setTranslate({ x: tx, y: ty });
    }, []);

    // Auto-fit whenever the tree is (re)drawn in tree mode or layout flips.
    // Round ORG-UAT-1 (2026) fix: react-d3-tree paints asynchronously and
    // animates node entry, so a single delayed measure often read a stale or
    // mid-transition bbox and the tree still sprawled. Retry a few times
    // until the measured width stabilizes, then do a final fit.
    useEffect(() => {
        if (viewMode !== "tree" || !treeData) return;
        let cancelled = false;
        let lastW = -1, stable = 0, tries = 0;
        const tick = () => {
            if (cancelled) return;
            const container = treeContainer.current;
            const g =
                container?.querySelector("svg g.rd3t-g") ||
                container?.querySelector("svg .rd3t-g") ||
                container?.querySelector("svg > g") ||
                container?.querySelector("svg g");
            let w = 0;
            try { w = g ? g.getBBox().width : 0; } catch { w = 0; }
            tries += 1;
            if (w > 0 && Math.abs(w - lastW) < 1) stable += 1; else stable = 0;
            lastW = w;
            // Fit once geometry is stable for 2 frames, or after ~1.6s.
            if ((w > 0 && stable >= 2) || tries > 20) {
                fitTreeToScreen(false);
                return;
            }
            setTimeout(tick, 80);
        };
        const t = setTimeout(tick, 80);
        // Round ORG-UAT-1 — keep it fitted when the window/panel resizes.
        const onResize = () => fitTreeToScreen(false);
        window.addEventListener("resize", onResize);
        return () => { cancelled = true; clearTimeout(t); window.removeEventListener("resize", onResize); };
    // Round ORG-2a — also re-fit when the legend filter changes the tree.
    }, [viewMode, treeData, fitTreeToScreen, legendFilter]);


    // Round ORG-UAT-1 — the canvas width changes when the side panel
    // opens/closes; re-fit so the tree stays centered and in-bounds.
    useEffect(() => {
        if (viewMode !== "tree" || !treeData) return;
        const t = setTimeout(() => fitTreeToScreen(true), 320); // after the panel transition
        return () => clearTimeout(t);
    }, [sidePanelOpen]);

    const handleReset = () => {
        if (!treeContainer.current) return;
        // Round ORG-2a — Reset also clears the legend department filter.
        setLegendFilter(null);
        // Round ORG-UAT-1 (2026) — in tree mode, Reset = fit the whole tree
        // to the screen (the real "make it not sprawl" action).
        if (viewMode === "tree") {
            fitTreeToScreen(true);
            return;
        }
        // Team view: return to the top of the org.
        if (treeData) drillInto(treeData);
    };

    // Round ORG-2 (Issue 5) — CSV export of the loaded chart (Team View
    // exports the current focus person + their whole team so the file matches
    // what's on screen; Tree View exports the full loaded tree). Client-side,
    // only fields already present in the authorized payload.
    const handleExportCsv = () => {
        const start = viewMode === "team" && !legendFilter && focusNode ? focusNode : treeData;
        if (!start) return;
        const out = [];
        const walk = (node, supervisorName) => {
            if (!node) return;
            // Round ORG-2a — with a legend filter active, export ONLY that
            // department's members (matches what's on screen).
            const include = !legendFilter || nodeDeptName(node) === legendFilter;
            if (include) out.push({
                name: node.name,
                empId: String(node.attributes?.empid || "").trim(),
                title: node.attributes?.title || "",
                departmentName: getDeptMeta(deptMap, node.attributes?.department).name,
                supervisorName: supervisorName || "",
                directReports: node.attributes?.directReports ?? (node.children?.length || 0),
                totalReports: node.attributes?.totalReports ?? flattenSubordinates(node).length,
                email: node.attributes?.email || "",
                extension: node.attributes?.extension || "",
            });
            (node.children || []).forEach((c) => walk(c, node.name));
        };
        walk(start, null);
        const fname = legendFilter
            ? `org-${legendFilter.replace(/\s+/g, "-")}.csv`
            : (viewMode === "team" && focusNode && focusNode !== treeData
                ? `team-${String(focusNode.name || "export").replace(/\s+/g, "-")}.csv`
                : "org-chart.csv");
        exportOrgRowsToCsv(out, fname);
    };

    /* ─── Center canvas on a node by name ────────────────────────────────── */
    const centerOnNode = (name) => {
        const nodeEl = document.getElementById(`node-${name.replace(/\s+/g, "-")}`);
        const canvasEl = treeContainer.current;
        if (!nodeEl || !canvasEl) return;
        const cRect = canvasEl.getBoundingClientRect();
        const nRect = nodeEl.getBoundingClientRect();
        const deltaX = cRect.width / 2 - (nRect.left - cRect.left + nRect.width / 2);
        const deltaY = cRect.height / 2 - (nRect.top - cRect.top + nRect.height / 2);
        smoothPan(translate.x + deltaX, translate.y + deltaY, 600);
    };

    /* ─── Open side panel for any node (with OR without subordinates) ─────── */
    // Round ORG-UAT-1 (2026) — Team View helpers.
    // Find the chain of ancestor nodes from the root down to a target node
    // (for the breadcrumb). Returns [] if not found.
    const findAncestryChain = (root, targetEmpId, chain = []) => {
        if (!root) return null;
        const next = [...chain, root];
        if (String(root.attributes?.empid) === String(targetEmpId)) return next;
        for (const c of root.children || []) {
            const hit = findAncestryChain(c, targetEmpId, next);
            if (hit) return hit;
        }
        return null;
    };

    const teamBreadcrumb = useMemo(() => {
        if (!treeData || !focusNode) return [];
        return findAncestryChain(treeData, focusNode.attributes?.empid) || [focusNode];
    }, [treeData, focusNode]);

    // Drill into a manager (make them the focus); leaf clicks just open panel.
    const drillInto = (node) => {
        setFocusNode(node);
        setSelectedNode({ datum: node, pos: null });
        fetchDetail(node.attributes?.empid);
    };

    const openSidePanel = (nodeDatum) => {
        const subs = flattenSubordinates(nodeDatum);
        setSidePanelNode(nodeDatum);
        setSidePanelSubList(subs);
        setSidePanelFilter("");
        setSidePanelDeptFilter("ALL");
        setSidePanelView("list");
        setSidePanelOpen(true);
    };

    /* ─── Node click ──────────────────────────────────────────────────────── */
    const handleNodeClick = (nodeDatum, toggleNode) => {
        setSelectedNode({ datum: nodeDatum, pos: null });
        setHighlightedNode(nodeDatum.name);
        fetchDetail(nodeDatum.attributes?.empid);
        openSidePanel(nodeDatum);
        // still toggle tree expand/collapse
        if (toggleNode) toggleNode();
        setTimeout(() => setHighlightedNode(null), 2000);
    };

    /* ─── Search select → expand path + open panel + center ─────────────── */
    const handleSearchSelect = (emp) => {
        setSearchQuery(emp.name);
        setSearchOpen(false);
        // Round ORG-2a — picking a person from search clears the department
        // filter so they're reachable even if outside the filtered dept.
        setLegendFilter(null);

        // Round ORG-UAT-1 (2026) — in Team View, focus the real node for the
        // searched person so their team grid + breadcrumb appear immediately.
        if (viewMode === "team" && treeData) {
            const chain = findAncestryChain(treeData, emp.empid);
            const realNode = chain ? chain[chain.length - 1] : null;
            if (realNode) {
                setFocusNode(realNode);
                setSelectedNode({ datum: realNode, pos: null });
                fetchDetail(emp.empid);
                return;
            }
        }

        // Build a minimal datum so side panel has something to show immediately
        const datum = {
            name: emp.name,
            photoBase64: emp.photoBase64,
            children: undefined,   // real children unknown until tree expands
            attributes: {
                empid: emp.empid,
                title: emp.title || "",
                department: emp.department || "",
                email: emp.email || "",
                cell: emp.cell || "",
            },
        };

        setSelectedNode({ datum, pos: null });
        setHighlightedNode(emp.name);
        fetchDetail(emp.empid);

        // Expand the tree path so the node is rendered
        const path = pathMap[emp.name];
        if (path && treeData) {
            const c = JSON.parse(JSON.stringify(treeData));
            expandPath(c, path);
            setTreeData(c);

            // After tree re-renders find the real node datum for the side panel
            setTimeout(() => {
                // Find real node in updated tree to get full children
                const findNode = (node, name) => {
                    if (!node) return null;
                    if (node.name === name) return node;
                    for (const child of node.children || []) {
                        const found = findNode(child, name);
                        if (found) return found;
                    }
                    return null;
                };
                const realNode = findNode(c, emp.name);
                if (realNode) openSidePanel(realNode);
                else openSidePanel(datum); // fallback with minimal datum
                centerOnNode(emp.name);
            }, 400);
        } else {
            openSidePanel(datum);
        }

        setTimeout(() => setHighlightedNode(null), 2000);
    };

    /* ─── Side panel computed data ────────────────────────────────────────── */
    const sidePanelDeptBreakdown = useMemo(
        () => buildDeptBreakdown(sidePanelSubList, deptMap),
        [sidePanelSubList, deptMap]
    );

    const sidePanelDeptTabs = useMemo(() => {
        const depts = [...new Set(sidePanelSubList.map((n) => String(n.attributes?.department || "").trim()))];
        return depts.map((k) => ({ key: k, ...getDeptMeta(deptMap, k) }));
    }, [sidePanelSubList, deptMap]);

    const sidePanelFiltered = useMemo(() => {
        let list = sidePanelSubList;
        if (sidePanelDeptFilter !== "ALL") {
            list = list.filter((n) => String(n.attributes?.department || "").trim() === sidePanelDeptFilter);
        }
        if (sidePanelFilter.trim()) {
            const q = sidePanelFilter.toLowerCase();
            list = list.filter((n) =>
                n.name?.toLowerCase().includes(q) ||
                n.attributes?.title?.toLowerCase().includes(q)
            );
        }
        return list;
    }, [sidePanelSubList, sidePanelDeptFilter, sidePanelFilter]);

    /* ─── Legend ─────────────────────────────────────────────────────────── */
    const legendItems = useMemo(() => {
        // Round ORG-UAT-1 (2026) — build the legend from RESOLVED department
        // meta and drop any code with no JCDepts-master name (e.g. "20", an
        // SN/legacy department). Previously such a code leaked into the
        // legend as a bare grey number.
        const usedKeys = new Set(flatList.map((e) => String(e.department || "").trim()).filter(Boolean));
        const seen = new Set();
        const items = [];
        [...usedKeys].forEach((k) => {
            const meta = getDeptMeta(deptMap, k);
            if (meta.unmatched) return;               // skip codes with no real name
            if (seen.has(meta.name)) return;          // de-dupe by name
            seen.add(meta.name);
            items.push(meta);
        });
        return items.sort((a, b) => a.name.localeCompare(b.name));
    }, [flatList, deptMap]);

    /* ─── Round ORG-2a — legend department FILTER (Team + Tree) ──────────── */
    // Match by RESOLVED name so multiple JCDept codes that share one
    // description (e.g. two HR codes) filter together — same rule the legend
    // uses to de-dupe its chips.
    const nodeDeptName = useCallback(
        (node) => getDeptMeta(deptMap, node?.attributes?.department).name,
        [deptMap]
    );

    // Tree View: prune to the selected department's members plus the ancestor
    // managers needed to keep the tree connected. Connectors are flagged
    // _filterGhost and render dimmed so the hierarchy is never misleading.
    const displayTreeData = useMemo(() => {
        if (!legendFilter || !treeData) return treeData;
        const prune = (node) => {
            if (!node) return null;
            const kids = (node.children || node._children || [])
                .map(prune)
                .filter(Boolean);
            const selfMatch = nodeDeptName(node) === legendFilter;
            if (!selfMatch && kids.length === 0) return null;
            return {
                ...node,
                _filterGhost: !selfMatch,
                children: kids.length ? kids : undefined,
                _children: undefined,
                __rd3t: undefined, // fresh copy → renders expanded so members are visible
            };
        };
        return prune(treeData);
    }, [legendFilter, treeData, nodeDeptName]);

    // Team View: with a filter active, show a flat grid of that department's
    // members instead of the manager drill-down (their members are scattered
    // across many managers, so a grid is the honest presentation).
    const legendFilterMembers = useMemo(() => {
        if (!legendFilter) return [];
        return flatList.filter((e) => getDeptMeta(deptMap, e.department).name === legendFilter);
    }, [legendFilter, flatList, deptMap]);

    // Find the REAL node in the tree for a flat-list entry (so the side panel
    // gets true children/subordinates).
    const findNodeByEmpId = useCallback((node, empid) => {
        if (!node) return null;
        if (String(node.attributes?.empid) === String(empid)) return node;
        for (const c of node.children || []) {
            const hit = findNodeByEmpId(c, empid);
            if (hit) return hit;
        }
        return null;
    }, []);

    const filteredResults = useMemo(() => {
        if (!searchQuery.trim()) return [];
        const q = searchQuery.toLowerCase();
        return flatList.filter((e) =>
            e.name?.toLowerCase().includes(q) ||
            e.title?.toLowerCase().includes(q) ||
            getDeptMeta(deptMap, e.department).name.toLowerCase().includes(q) ||
            // Round ORG-2 (Issue 12) — search by EmpID and email as well.
            String(e.empid || "").trim().toLowerCase().includes(q) ||
            (e.email || "").toLowerCase().includes(q)
        ).slice(0, 8);
    }, [searchQuery, flatList, deptMap]);

    /* ─── Render node ─────────────────────────────────────────────────────── */
    const renderNode = ({ nodeDatum, toggleNode }) => {
        const { name, attributes, photoBase64, children } = nodeDatum;
        const deptMeta = getDeptMeta(deptMap, attributes?.department);
        const isSelected = selectedNode?.datum?.name === name;
        const isHighlighted = highlightedNode === name;
        const subCount = countDescendants(nodeDatum);
        const hasChildren = subCount > 0;

        return (
            <g id={`node-${name.replace(/\s+/g, "-")}`}>
                <foreignObject width={230} height={130} x={-115} y={-65}>
                    <div
                        className={`oc-card ${isSelected ? "oc-card--selected" : ""} ${isHighlighted ? "oc-card--highlight" : ""}`}
                        onClick={() => handleNodeClick(nodeDatum, toggleNode)}
                        /* Round ORG-2a — with a legend filter active, ancestor
                           managers kept only to connect the tree render dimmed. */
                        style={nodeDatum._filterGhost ? { opacity: 0.32, filter: "grayscale(0.5)" } : undefined}
                    >
                        <div className="oc-card__bar" style={{ background: deptMeta.color }} />
                        <div className="oc-card__body">
                            <div className="oc-card__avatar-wrap">
                                <img
                                    src={photoBase64 ? `data:image/jpeg;base64,${photoBase64}` : MyImg}
                                    alt={name}
                                    className="oc-card__avatar"
                                />
                                <PresenceDot status={presenceOf(attributes?.empid)} />
                            </div>
                            <div className="oc-card__text">
                                <div className="oc-card__name">{name}</div>
                                <div className="oc-card__title">{attributes?.title || "—"}</div>
                                <div className="oc-card__dept-chip" style={{ background: `${deptMeta.color}18`, color: inkFor(deptMeta.color) }}>
                                    {deptMeta.name}
                                </div>
                            </div>
                        </div>
                        {hasChildren && (
                            <div className="oc-card__badge" style={{ background: deptMeta.color }}>
                                {subCount} ▾
                            </div>
                        )}
                    </div>
                </foreignObject>
            </g>
        );
    };

    /* ─── Side Panel Component ────────────────────────────────────────────── */
    const SidePanel = () => {
        if (!sidePanelOpen || !sidePanelNode) return null;

        const panelDeptMeta = getDeptMeta(deptMap, sidePanelNode.attributes?.department);
        const directCount = sidePanelNode.children?.length || 0;
        const totalCount = sidePanelSubList.length;
        const deptCount = sidePanelDeptBreakdown.length;
        const maxBarCount = sidePanelDeptBreakdown[0]?.count || 1;

        return (
            <div className="oc-side-panel">
                {/* ── Header ── */}
                <div className="oc-sp__header" style={{ borderBottom: `3px solid ${panelDeptMeta.color}` }}>
                    <div className="oc-sp__header-left">
                        <span className="oc-presence-wrap">
                            <img
                                src={sidePanelNode.photoBase64 ? `data:image/jpeg;base64,${sidePanelNode.photoBase64}` : MyImg}
                                alt={sidePanelNode.name}
                                className="oc-sp__photo"
                            />
                            <PresenceDot status={presenceOf(sidePanelNode.attributes?.empid)} />
                        </span>
                        <div>
                            <div className="oc-sp__name">{sidePanelNode.name}</div>
                            <div className="oc-sp__role" style={{ color: panelDeptMeta.color }}>
                                {sidePanelNode.attributes?.title || "—"}
                            </div>
                            <PresencePill status={presenceOf(sidePanelNode.attributes?.empid)} className="mt-1" />
                        </div>
                    </div>
                    <button className="oc-sp__close" onClick={() => setSidePanelOpen(false)}>×</button>
                </div>

                {/* ── Stat chips ── */}
                <div className="oc-sp__stats">
                    <div className="oc-sp__stat">
                        <div className="oc-sp__stat-num">{totalCount}</div>
                        <div className="oc-sp__stat-lbl">Total reports</div>
                    </div>
                    <div className="oc-sp__stat">
                        <div className="oc-sp__stat-num">{directCount}</div>
                        <div className="oc-sp__stat-lbl">Direct reports</div>
                    </div>
                    <div className="oc-sp__stat">
                        <div className="oc-sp__stat-num">{deptCount}</div>
                        <div className="oc-sp__stat-lbl">Departments</div>
                    </div>
                </div>

                {/* ── View toggle ── */}
                <div className="oc-sp__view-toggle">
                    <button
                        className={`oc-sp__vbtn ${sidePanelView === "list" ? "active" : ""}`}
                        onClick={() => setSidePanelView("list")}
                    >
                        <i className="ri-list-unordered" /> People
                    </button>
                    <button
                        className={`oc-sp__vbtn ${sidePanelView === "summary" ? "active" : ""}`}
                        onClick={() => setSidePanelView("summary")}
                    >
                        <i className="ri-bar-chart-2-line" /> Departments
                    </button>
                    <button
                        className={`oc-sp__vbtn ${sidePanelView === "details" ? "active" : ""}`}
                        onClick={() => setSidePanelView("details")}
                    >
                        <i className="ri-id-card-line" /> Details
                    </button>
                </div>

                {/* ── LIST VIEW ── */}
                {sidePanelView === "list" && (
                    <>
                        {/* Dept filter tabs */}
                        <div className="oc-sp__dept-tabs">
                            <button
                                className={`oc-sp__dtab ${sidePanelDeptFilter === "ALL" ? "active" : ""}`}
                                onClick={() => setSidePanelDeptFilter("ALL")}
                            >
                                All ({totalCount})
                            </button>
                            {sidePanelDeptTabs.map((d) => {
                                const cnt = sidePanelSubList.filter(
                                    (n) => String(n.attributes?.department || "").trim() === d.key
                                ).length;
                                return (
                                    <button
                                        key={d.key}
                                        className={`oc-sp__dtab ${sidePanelDeptFilter === d.key ? "active" : ""}`}
                                        style={sidePanelDeptFilter === d.key ? { borderColor: d.color, color: d.color } : {}}
                                        onClick={() => setSidePanelDeptFilter(d.key)}
                                    >
                                        <span className="oc-sp__dtab-dot" style={{ background: d.color }} />
                                        {d.name} ({cnt})
                                    </button>
                                );
                            })}
                        </div>

                        {/* Search within panel */}
                        <div className="oc-sp__search-wrap">
                            <i className="ri-search-line oc-sp__search-icon" />
                            <input
                                type="text"
                                className="oc-sp__search"
                                placeholder="Search name or title…"
                                value={sidePanelFilter}
                                onChange={(e) => setSidePanelFilter(e.target.value)}
                            />
                            {sidePanelFilter && (
                                <button className="oc-sp__search-clear" onClick={() => setSidePanelFilter("")}>×</button>
                            )}
                        </div>

                        {/* Scrollable employee list */}
                        <div className="oc-sp__list">
                            {sidePanelFiltered.length === 0 && (
                                <div className="oc-sp__empty">No employees match your filter.</div>
                            )}
                            {sidePanelFiltered.map((node, idx) => {
                                const dm = getDeptMeta(deptMap, node.attributes?.department);
                                return (
                                    <div
                                        key={`${node.name}-${idx}`}
                                        className="oc-sp__emp-row"
                                        onClick={() => {
                                            fetchDetail(node.attributes?.empid);
                                            setSelectedNode({ datum: node, pos: null });
                                            setHighlightedNode(node.name);
                                            setTimeout(() => setHighlightedNode(null), 2000);
                                        }}
                                    >
                                        <img
                                            src={node.photoBase64 ? `data:image/jpeg;base64,${node.photoBase64}` : MyImg}
                                            alt={node.name}
                                            className="oc-sp__emp-avatar"
                                        />
                                        <div className="oc-sp__emp-info">
                                            <div className="oc-sp__emp-name">{node.name}</div>
                                            <div className="oc-sp__emp-title">{node.attributes?.title || "—"}</div>
                                        </div>
                                        <span className="oc-sp__emp-chip" style={{ background: `${dm.color}18`, color: inkFor(dm.color) }}>
                                            {dm.name}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="oc-sp__count-footer">
                            Showing {sidePanelFiltered.length} of {totalCount} employees
                        </div>
                    </>
                )}

                {/* ── DETAILS VIEW ── */}
                {sidePanelView === "details" && (
                    <div className="oc-sp__details">
                        <div className="oc-sp__detail-row">
                            <div className="oc-sp__detail-icon"><i className="ri-mail-line" /></div>
                            <div>
                                <div className="oc-sp__detail-label">Email</div>
                                <div className="oc-sp__detail-val">
                                    {/* Round ORG-2 — mailto link (legacy parity); the API
                                        serializes EmailAddress as emailAddress. */}
                                    {(() => {
                                        const em = employeeDetails?.emailAddress || employeeDetails?.email || sidePanelNode?.attributes?.email;
                                        return em ? <a href={`mailto:${em}`}>{em}</a> : "—";
                                    })()}
                                </div>
                            </div>
                        </div>
                        <div className="oc-sp__detail-row">
                            <div className="oc-sp__detail-icon"><i className="ri-phone-line" /></div>
                            <div>
                                <div className="oc-sp__detail-label">Extension</div>
                                <div className="oc-sp__detail-val">
                                    {/* Round ORG-2 — desk extension (Employees.DeskPhone), tel: link. */}
                                    {(() => {
                                        const ext = employeeDetails?.extension || sidePanelNode?.attributes?.extension;
                                        return ext ? <a href={`tel:${ext}`}>{ext}</a> : "—";
                                    })()}
                                </div>
                            </div>
                        </div>
                        <div className="oc-sp__detail-row">
                            <div className="oc-sp__detail-icon"><i className="ri-smartphone-line" /></div>
                            <div>
                                <div className="oc-sp__detail-label">Company Cell</div>
                                <div className="oc-sp__detail-val">
                                    {/* Round ORG-2 — company cell (was the PERSONAL phone before
                                        the backend privacy fix), tel: link. */}
                                    {(() => {
                                        const cell = employeeDetails?.cell || sidePanelNode?.attributes?.cell;
                                        return cell ? <a href={`tel:${cell}`}>{cell}</a> : "—";
                                    })()}
                                </div>
                            </div>
                        </div>
                        <div className="oc-sp__detail-row">
                            <div className="oc-sp__detail-icon"><i className="ri-building-line" /></div>
                            <div>
                                <div className="oc-sp__detail-label">Department</div>
                                <div className="oc-sp__detail-val">
                                    {employeeDetails?.departmentName || getDeptMeta(deptMap, sidePanelNode?.attributes?.department).name || "—"}
                                </div>
                            </div>
                        </div>
                        {employeeDetails?.managerName && (
                            <div className="oc-sp__detail-row">
                                <div className="oc-sp__detail-icon"><i className="ri-user-star-line" /></div>
                                <div>
                                    <div className="oc-sp__detail-label">Reports To</div>
                                    <div className="oc-sp__detail-val">{employeeDetails.managerName}</div>
                                </div>
                            </div>
                        )}
                        {/* Go-live parity (2026-09-24): legacy HR could edit title,
                            photo and supervisor from the chart. That editing lives in
                            HR › Employees (supervisor also goes to Epicor); HR gets a
                            shortcut there from every person. */}
                        {canEditInHr && (
                            <div className="oc-sp__detail-row">
                                <div className="oc-sp__detail-icon"><i className="ri-edit-2-line" /></div>
                                <div>
                                    <div className="oc-sp__detail-label">HR</div>
                                    <div className="oc-sp__detail-val">
                                        <Link to="/humanresource?section=employees&view=list" title="Edit title, photo or supervisor in HR › Employees">
                                            Edit in HR
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="oc-sp__detail-meta-grid">
                            <div className="oc-sp__detail-meta-card">
                                <div className="oc-sp__detail-label">Joined On</div>
                                <div className="oc-sp__detail-meta-val">
                                    {employeeDetails?.hireDate
                                        ? new Date(employeeDetails.hireDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
                                        : "—"}
                                </div>
                            </div>
                            {/* Round ORG-2 — DOB is HR-only. The backend nulls dob for
                                non-HR callers (server-side JWT check), so this card only
                                renders when a value actually came back. */}
                            {employeeDetails?.dob && (
                                <div className="oc-sp__detail-meta-card">
                                    <div className="oc-sp__detail-label">Date of Birth</div>
                                    <div className="oc-sp__detail-meta-val">
                                        {new Date(employeeDetails.dob).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                                    </div>
                                </div>
                            )}
                            {/* Round ORG-2 — legacy LoSTextBox parity. */}
                            <div className="oc-sp__detail-meta-card">
                                <div className="oc-sp__detail-label">Length of Service</div>
                                <div className="oc-sp__detail-meta-val">
                                    {lengthOfService(employeeDetails?.hireDate) || "—"}
                                </div>
                            </div>
                            <div className="oc-sp__detail-meta-card">
                                <div className="oc-sp__detail-label">Employee ID</div>
                                <div className="oc-sp__detail-meta-val">
                                    {sidePanelNode?.attributes?.empid || "—"}
                                </div>
                            </div>
                            <div className="oc-sp__detail-meta-card">
                                <div className="oc-sp__detail-label">Direct Reports</div>
                                <div className="oc-sp__detail-meta-val">
                                    {employeeDetails?.directReports ?? (sidePanelNode?.children?.length || 0)}
                                </div>
                            </div>
                            {/* Round ORG-2 — legacy Headcount parity (total reports). */}
                            <div className="oc-sp__detail-meta-card">
                                <div className="oc-sp__detail-label">Total Reports</div>
                                <div className="oc-sp__detail-meta-val">
                                    {employeeDetails?.totalReports ?? flattenSubordinates(sidePanelNode).length}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── SUMMARY VIEW ── */}
                {sidePanelView === "summary" && (
                    <div className="oc-sp__summary">
                        {sidePanelDeptBreakdown.map((d) => (
                            <div key={d.key} className="oc-sp__dept-row">
                                <div className="oc-sp__dept-label">
                                    <span className="oc-sp__dept-dot" style={{ background: d.color }} />
                                    <span className="oc-sp__dept-name">{d.name}</span>
                                </div>
                                <div className="oc-sp__dept-bar-wrap">
                                    <div
                                        className="oc-sp__dept-bar"
                                        style={{ width: `${(d.count / maxBarCount) * 100}%`, background: d.color }}
                                    />
                                </div>
                                <span className="oc-sp__dept-count">{d.count}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    /* ─── JSX ────────────────────────────────────────────────────────────── */
    // Round ORG-2 — no blank page: show a controlled error, or a lightweight
    // loading state while the first payload is in flight.
    if (loadError) {
        return <Alert color="danger" className="mt-3">{loadError}</Alert>;
    }
    if (!treeData) {
        return (
            <Card className="oc-main-card">
                <CardBody className="oc-main-body text-center py-5">
                    <div className="spinner-border text-primary" role="status" />
                    <div className="text-muted mt-2">Loading organization…</div>
                </CardBody>
            </Card>
        );
    }

    return (
        <React.Fragment>
            <Card className="oc-main-card">
                <CardBody className="oc-main-body">

                    {/* Toolbar */}
                    <div className="oc-toolbar">
                        <div className="oc-search-wrap">
                            <i className="ri-search-line oc-search-icon" />
                            <input
                                type="text"
                                placeholder="Search for employee, department…"
                                value={searchQuery}
                                className="oc-search"
                                onChange={(e) => { setSearchQuery(e.target.value); setSearchOpen(true); }}
                                onFocus={() => setSearchOpen(true)}
                                onBlur={() => setTimeout(() => setSearchOpen(false), 150)}
                            />
                            {searchOpen && filteredResults.length > 0 && (
                                <div className="oc-search-dropdown">
                                    {filteredResults.map((emp, i) => (
                                        <div key={`${emp.name}-${i}`} className="oc-search-item" onMouseDown={() => handleSearchSelect(emp)}>
                                            <img src={emp.photoBase64 ? `data:image/jpeg;base64,${emp.photoBase64}` : MyImg} alt={emp.name} className="oc-search-thumb" />
                                            <div>
                                                <div className="oc-search-name">{emp.name}</div>
                                                <div className="oc-search-sub">{emp.title}{emp.department ? ` • ${getDeptMeta(deptMap, emp.department).name}` : ""}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="oc-toolbar-btns">
                            <button type="button" className="oc-btn" onClick={handleReset}><i className="ri-refresh-line" /> Reset View</button>
                            <button type="button" className="oc-btn" onClick={handleExportCsv} title="Download the current view as a CSV"><i className="ri-download-2-line" /> Export CSV</button>
                            <button type="button" className="oc-btn" onClick={() => setShowLegend((v) => !v)}><i className="ri-information-line" /> {showLegend ? "Hide Legend" : "Show Legend"}</button>
                            {viewMode === "tree" && (
                            <button type="button" className="oc-btn" onClick={() => fitTreeToScreen(true)} title="Scale the whole tree to fit the screen">
                                <i className="ri-fullscreen-fill" /> Fit to screen
                            </button>
                            )}
                            {viewMode === "tree" && (
                            <button type="button" className="oc-btn" onClick={() => { const c = JSON.parse(JSON.stringify(treeData)); expandAllNodes(c); setTreeData(c); setTimeout(() => fitTreeToScreen(true), 200); }}><i className="ri-fullscreen-line" /> Expand All</button>
                            )}
                            {viewMode === "tree" && (
                            <button type="button" className="oc-btn" onClick={() => { const c = JSON.parse(JSON.stringify(treeData)); collapseAllNodes(c, true); setTreeData(c); setTimeout(() => fitTreeToScreen(true), 200); }}><i className="ri-collapse-diagonal-line" /> Collapse All</button>
                            )}
                        </div>
                    </div>

                    {/* Legend */}
                    {showLegend && (
                        <div className="oc-legend">
                            <div className="oc-legend__total">
                                {legendFilter
                                    ? <><strong>Showing:</strong> {legendFilterMembers.length} of {flatList.length}</>
                                    : <><strong>Total Employees:</strong> {flatList.length}</>}
                                <PresenceReadout presence={presence} className="ms-3" />
                            </div>
                            <div className="oc-legend__items">
                                <span className="oc-legend__label">Departments&nbsp;:</span>
                                {/* Round ORG-2a — chips are a FILTER: click a
                                    department to show only its people (all
                                    views); click again or Clear to restore. */}
                                {legendItems.map((item) => {
                                    const cnt = flatList.filter((e) => getDeptMeta(deptMap, e.department).name === item.name).length;
                                    const active = legendFilter === item.name;
                                    return (
                                        <button
                                            key={item.name}
                                            type="button"
                                            className="oc-legend__chip"
                                            onClick={() => setLegendFilter((cur) => (cur === item.name ? null : item.name))}
                                            title={active ? "Click to show all departments again" : "Click to show only this department"}
                                            style={{
                                                cursor: "pointer",
                                                border: active ? `1.5px solid ${item.color}` : "1px solid transparent",
                                                background: active ? `${item.color}18` : "transparent",
                                                borderRadius: 20,
                                                fontWeight: active ? 600 : undefined,
                                            }}
                                        >
                                            <span
                                                className="oc-legend__dot"
                                                style={{ background: item.color }}
                                            />
                                            {item.name || "Unknown"}
                                            <span style={{ fontSize: 10.5, fontWeight: 700, color: "#5b6478", background: "#eef0f6", borderRadius: 10, padding: "0 6px", marginLeft: 4 }}>{cnt}</span>
                                        </button>
                                    );
                                })}
                                {legendFilter && (
                                    <button type="button" className="oc-btn" style={{ padding: "2px 8px" }} onClick={() => setLegendFilter(null)}>
                                        <i className="ri-close-line" /> Clear filter
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Canvas + Side Panel wrapper */}
                    <div className={`oc-workspace ${sidePanelOpen ? "oc-workspace--panel-open" : ""}`}>

                        {/* Round ORG-2a — Team View with a legend filter: the
                            department's members are scattered across many
                            managers, so show them as ONE flat grid (the honest
                            presentation) instead of the drill-down. Clear the
                            filter to return to the manager drill-down. */}
                        {viewMode === "team" && legendFilter && (
                            <div className="oc-teamview">
                                <div className="oc-tv-section-label">
                                    {legendFilter} — {legendFilterMembers.length} employee{legendFilterMembers.length === 1 ? "" : "s"}
                                    <button
                                        type="button"
                                        className="oc-btn"
                                        style={{ marginLeft: 10, padding: "2px 8px" }}
                                        onClick={() => setLegendFilter(null)}
                                    >
                                        <i className="ri-close-line" /> Clear filter
                                    </button>
                                </div>
                                {legendFilterMembers.length === 0 && (
                                    <div className="oc-tv-empty">
                                        <i className="ri-filter-off-line" /> No {legendFilter} employees found.
                                    </div>
                                )}
                                <div className="oc-tv-grid">
                                    {legendFilterMembers.map((emp) => {
                                        const dm = getDeptMeta(deptMap, emp.department);
                                        return (
                                            <div key={emp.empid} className="oc-tv-card" style={{ borderTopColor: dm.color }}>
                                                <div
                                                    className="oc-tv-card-main"
                                                    onClick={() => {
                                                        const realNode = findNodeByEmpId(treeData, emp.empid) || {
                                                            name: emp.name,
                                                            photoBase64: emp.photoBase64,
                                                            attributes: { ...emp },
                                                        };
                                                        openSidePanel(realNode);
                                                        fetchDetail(emp.empid);
                                                        setSelectedNode({ datum: realNode, pos: null });
                                                    }}
                                                >
                                                    <span className="oc-presence-wrap">
                                                        <img
                                                            className="oc-tv-card-photo"
                                                            src={emp.photoBase64 ? `data:image/jpeg;base64,${emp.photoBase64}` : MyImg}
                                                            alt={emp.name}
                                                        />
                                                        <PresenceDot status={presenceOf(emp.empid)} />
                                                    </span>
                                                    <div className="oc-tv-card-name">{emp.name}</div>
                                                    <div className="oc-tv-card-title">{emp.title || "—"}</div>
                                                    <span className="oc-tv-card-dept" style={{ background: `${dm.color}18`, color: inkFor(dm.color) }}>{dm.name}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Round ORG-UAT-1 (2026) — DRILL-DOWN TEAM VIEW */}
                        {viewMode === "team" && !legendFilter && focusNode && (
                            <div className="oc-teamview">
                                {/* Breadcrumb trail */}
                                <div className="oc-tv-breadcrumb">
                                    {teamBreadcrumb.map((n, i) => (
                                        <React.Fragment key={n.attributes?.empid || i}>
                                            {i > 0 && <i className="ri-arrow-right-s-line oc-tv-sep" />}
                                            <button
                                                type="button"
                                                className={`oc-tv-crumb ${i === teamBreadcrumb.length - 1 ? "active" : ""}`}
                                                onClick={() => drillInto(n)}
                                            >
                                                {i === 0 ? <i className="ri-home-4-line me-1" /> : null}
                                                {n.name}
                                            </button>
                                        </React.Fragment>
                                    ))}
                                </div>

                                {/* Manager hero card */}
                                {(() => {
                                    const dm = getDeptMeta(deptMap, focusNode.attributes?.department);
                                    const directs = focusNode.children?.length || 0;
                                    const total = flattenSubordinates(focusNode).length;
                                    return (
                                        <div className="oc-tv-hero" style={{ borderTopColor: dm.color }}>
                                            <span className="oc-presence-wrap">
                                                <img
                                                    className="oc-tv-hero-photo"
                                                    src={focusNode.photoBase64 ? `data:image/jpeg;base64,${focusNode.photoBase64}` : MyImg}
                                                    alt={focusNode.name}
                                                />
                                                <PresenceDot status={presenceOf(focusNode.attributes?.empid)} size="lg" />
                                            </span>
                                            <div className="oc-tv-hero-info">
                                                <div className="oc-tv-hero-name">{focusNode.name}</div>
                                                <div className="oc-tv-hero-title">{focusNode.attributes?.title || "—"}</div>
                                                <span className="oc-tv-hero-dept" style={{ background: `${dm.color}18`, color: inkFor(dm.color) }}>{dm.name}</span>
                                            </div>
                                            <div className="oc-tv-hero-stats">
                                                <div><strong>{directs}</strong><span>Direct</span></div>
                                                <div><strong>{total}</strong><span>Total</span></div>
                                                <button className="oc-tv-hero-details" onClick={() => { openSidePanel(focusNode); fetchDetail(focusNode.attributes?.empid); }}>
                                                    <i className="ri-id-card-line me-1" />View details
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* Direct-reports grid */}
                                {focusNode.children?.length ? (
                                    <>
                                        <div className="oc-tv-section-label">
                                            Direct reports ({focusNode.children.length})
                                        </div>
                                        <div className="oc-tv-grid">
                                            {focusNode.children.map((child) => {
                                                const cdm = getDeptMeta(deptMap, child.attributes?.department);
                                                const cDirects = child.children?.length || 0;
                                                const cTotal = flattenSubordinates(child).length;
                                                return (
                                                    <div key={child.attributes?.empid} className="oc-tv-card" style={{ borderTopColor: cdm.color }}>
                                                        <div className="oc-tv-card-main" onClick={() => { openSidePanel(child); fetchDetail(child.attributes?.empid); setSelectedNode({ datum: child, pos: null }); }}>
                                                            <span className="oc-presence-wrap">
                                                                <img
                                                                    className="oc-tv-card-photo"
                                                                    src={child.photoBase64 ? `data:image/jpeg;base64,${child.photoBase64}` : MyImg}
                                                                    alt={child.name}
                                                                />
                                                                <PresenceDot status={presenceOf(child.attributes?.empid)} />
                                                            </span>
                                                            <div className="oc-tv-card-name">{child.name}</div>
                                                            <div className="oc-tv-card-title">{child.attributes?.title || "—"}</div>
                                                            <span className="oc-tv-card-dept" style={{ background: `${cdm.color}18`, color: inkFor(cdm.color) }}>{cdm.name}</span>
                                                        </div>
                                                        {cDirects > 0 && (
                                                            <button className="oc-tv-card-drill" onClick={() => drillInto(child)} title={`${cDirects} direct / ${cTotal} total reports`}>
                                                                <i className="ri-team-line me-1" />
                                                                View team ({cDirects})
                                                                <i className="ri-arrow-right-s-line" />
                                                            </button>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                ) : (
                                    <div className="oc-tv-empty">
                                        <i className="ri-user-follow-line" /> {focusNode.name} has no direct reports.
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Tree canvas */}
                        {viewMode === "tree" && (
                        <div className="oc-canvas" ref={treeContainer}>
                            <div className="oc-tip"><strong>Tip :</strong> The tree starts collapsed — click a node's <b>+</b> to expand that branch. Use <b>Fit to screen</b> anytime.</div>

                            {treeData && legendFilter && !displayTreeData && (
                                <div className="oc-tv-empty" style={{ margin: 16 }}>
                                    <i className="ri-filter-off-line" /> No {legendFilter} employees in the tree.
                                </div>
                            )}
                            {treeData && (!legendFilter || displayTreeData) && (
                                <Tree
                                    data={legendFilter ? displayTreeData : treeData}
                                    translate={translate}
                                    zoom={zoom}
                                    onZoom={setZoom}
                                    // Round ORG-UAT-1 (2026) — the honest fix
                                    // for "78 boxes across one screen": don't
                                    // show them all at once. initialDepth={1}
                                    // opens the tree COLLAPSED to the CEO + one
                                    // level; every node with reports shows a
                                    // "+ N" toggle, so you expand only the
                                    // branch you care about. Combined with the
                                    // horizontal (indented) orientation, a wide
                                    // level stacks VERTICALLY and scrolls
                                    // instead of shrinking to an unreadable
                                    // strip. This is how BambooHR / Lucidchart
                                    // handle deep, wide orgs.
                                    // Filter active → open fully expanded so
                                    // every member is visible; otherwise the
                                    // usual collapsed depth-1 start.
                                    initialDepth={legendFilter ? undefined : 1}
                                    orientation="vertical"
                                    pathFunc="step"
                                    collapsible
                                    zoomable
                                    // Round ORG-UAT-1 (2026) — allow the
                                    // auto-fit to shrink a very wide tree
                                    // (78 siblings) far enough to fit; the old
                                    // 0.3 floor left it sprawling.
                                    scaleExtent={{ min: 0.04, max: 2 }}
                                    separation={{ siblings: 1.1, nonSiblings: 1.4 }}
                                    nodeSize={{ x: 245, y: 150 }}
                                    transitionDuration={350}
                                    renderCustomNodeElement={renderNode}
                                />
                            )}
                        </div>
                        )}

                        {/* Side Panel */}
                        <SidePanel />
                    </div>

                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default OrganizationalChart;